import $api from "../http";
import {AxiosResponse} from 'axios';

export default class PaymentService {
    static async pay(sum: string, email: string, isPositive: boolean): Promise<AxiosResponse>{
        return $api.post("/pay", {sum, email, isPositive})
    }
}